<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType" id="msgWnd"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>

      <div class="card_container">
        <b-card>
          <div slot="header" class="d-flex">
            <strong class="mdrive-header-text">Calculation Settings</strong>
            <button id="btnSave" class="btn btn-info ml-auto" @click="saveOptions"><i title="Save" class="fa fa-save fa-lg text-white"></i> <strong class="text-white">Save</strong></button>
          </div>
          <b-row md="12" >
            <div  class="card_container_body">
              <table aria-busy="false" class="table b-table table-sm ">
                <tbody>
                  <tr v-if="!calcSettings.length" class="b-table-empty-row">
                    <td><div role="alert" aria-live="polite"><div class="text-center my-2">No market options loaded yet.</div></div></td>
                  </tr>
                  <tr>
                    <td >
                      <b-row >
                        <b-col md="3"><strong>Lease &amp; Retail</strong></b-col>
                        <b-col md="9" >
                          <table aria-busy="false" class="table b-table table-sm mb-0 border-bottom">
                            <tbody>
                              <tr v-for="(mp, mi) in calcSettings" v-if="mp.__type != 'array'">
                                <td>
                                  <b-row>
                                    <b-col md="9" :id="mp.name">{{ mp.description }}</b-col>
                                    <b-col md="3">
                                      <slot v-if="mp.__type === 'int'">
                                        <b-form-input :id="mp.name" size="sm" type="number" v-model.number="mp.value"></b-form-input>
                                      </slot>
                                      <slot v-else-if="mp.__type === 'decimal'">
                                        <b-form-input :id="mp.name" size="sm" type="number" v-model="mp.value"></b-form-input>
                                      </slot>
                                      <slot v-else-if="mp.__type === 'enum'">
                                        <b-form-select :id="mp.name" v-model="mp.value" required>
                                          <option v-for="o in v.values" :value="o.name">{{ o.description }}</option>
                                        </b-form-select>
                                      </slot>
                                      <slot v-else-if="mp.__type === 'boolean'">
                                        <c-switch :id="mp.name" size="sm" v-model="mp.value" type="text" variant="primary" on="On" off="Off" :pill="true" />
                                      </slot>
                                      <slot v-else>
                                        <b-form-input :id="mp.name" size="sm" type="text" v-model="mp.value"></b-form-input>
                                      </slot>
                                    </b-col>
                                  </b-row>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </b-col>
                      </b-row>
                    </td>
                  </tr>
                  <tr v-for="(mp, mi) in calcSettings" v-if="mp.__type === 'array'">
                    <td>
                      <b-row>
                        <b-col md="3" lg="3"><strong>{{ mp.description }}</strong></b-col>
                        <b-col md="9" lg="9">
                          <table aria-busy="false" class="table b-table table-sm mb-0 border-bottom">
                            <tbody>
                              <tr v-for="(mpp, mii) in mp.value">
                                <td>
                                  <b-row :id=mii>
                                    <b-col md="9">{{ mpp.description }}</b-col>
                                    <b-col md="3">
                                      <slot v-if="mpp.__type === 'int'">
                                        <b-form-input :id="mpp.name" size="sm" type="number" v-model.number="mpp.value"></b-form-input>
                                      </slot>
                                      <slot v-else-if="mpp.__type === 'decimal'">
                                        <b-form-input :id="mpp.name" size="sm" type="number" v-model="mpp.value"></b-form-input>
                                      </slot>
                                      <slot v-else-if="mpp.__type === 'enum'">
                                        <b-form-select :id="mpp.name" v-model="mpp.value" required>
                                          <option v-for="o in mpp.values" :value="o.name">{{ o.description }}</option>
                                        </b-form-select>
                                      </slot>
                                      <slot v-else-if="mpp.__type === 'boolean'">
                                        <c-switch :id="mpp.name" size="sm" v-model="mpp.value" type="text" variant="primary" on="On" off="Off" :pill="true" />
                                      </slot>
                                      <slot v-else>
                                        <b-form-input :id="mpp.name" size="sm" type="text" v-model="mpp.value"></b-form-input>
                                      </slot>
                                    </b-col>
                                  </b-row>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </b-col>
                      </b-row>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-row>
        </b-card>
      </div>

      <div class="card_container">
        <b-card>
          <div slot="header">
            <strong>Calculation Filters</strong>
          </div>
          <b-row>
            <div class="card_container_body">
              <table aria-busy="false" class="table b-table table-sm">
                <tbody>
                  <tr v-if="!calcFilters.length" class="b-table-empty-row">
                    <td><div role="alert" aria-live="polite"><div class="text-center my-2">No filter options loaded yet.</div></div></td>
                  </tr>
                  <tr>
                    <td>
                      <b-row>
                        <b-col md="3"><strong>Lease &amp; Retail</strong></b-col>
                        <b-col md="9">
                          <table aria-busy="false" class="table b-table table-sm mb-0 border-bottom">
                            <tbody>
                              <tr v-for="(mp, mi) in calcFilters" v-if="mp.__type != 'array'">
                                <td>
                                  <b-row>
                                    <b-col md="9">{{ mp.description }}</b-col>
                                    <b-col md="3">
                                      <slot v-if="mp.__type === 'int'">
                                        <b-form-input :id="mp.name" size="sm" type="number" v-model.number="mp.value"></b-form-input>
                                      </slot>
                                      <slot v-else-if="mp.__type === 'decimal'">
                                        <b-form-input :id="mp.name" size="sm" type="number" v-model="mp.value"></b-form-input>
                                      </slot>
                                      <slot v-else-if="mp.__type === 'enum'">
                                        <b-form-select :id="mp.name" v-model="mp.value" required>
                                          <option v-for="o in mp.values" :value="o.name">{{ o.description }}</option>
                                        </b-form-select>
                                      </slot>
                                      <slot v-else-if="mp.__type === 'boolean'">
                                        <c-switch :id="mp.name" size="sm" v-model="mp.value" type="text" variant="primary" on="On" off="Off" :pill="true" />
                                      </slot>
                                      <slot v-else>
                                        <b-form-input :id="mp.name" size="sm" type="text" v-model="mp.value"></b-form-input>
                                      </slot>
                                    </b-col>
                                  </b-row>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </b-col>
                      </b-row>
                    </td>
                  </tr>
                  <tr v-for="(mp, mi) in calcFilters" v-if="mp.__type === 'array'">
                    <td>
                      <b-row>
                        <b-col md="3"><strong>{{ mp.description }}</strong></b-col>
                        <b-col md="9">
                          <table aria-busy="false" class="table b-table table-sm mb-0 border-bottom">
                            <tbody>
                              <tr v-for="(mpp, mii) in mp.value">
                                <td>
                                  <b-row>
                                    <b-col md="9" :id="mii">{{ mpp.description }}</b-col>
                                    <b-col md="3">
                                      <slot v-if="mpp.__type === 'int'">
                                        <b-form-input :id="mpp.name" size="sm" type="number" v-model.number="mpp.value"></b-form-input>
                                      </slot>
                                      <slot v-else-if="mpp.__type === 'decimal'">
                                        <b-form-input :id="mpp.name" size="sm" type="number" v-model="mpp.value"></b-form-input>
                                      </slot>
                                      <slot v-else-if="mpp.__type === 'enum'">
                                        <b-form-select :id="mpp.name" v-model="mpp.value" required>
                                          <option v-for="o in mpp.values" :value="o.name">{{ o.description }}</option>
                                        </b-form-select>
                                      </slot>
                                      <slot v-else-if="mpp.__type === 'boolean'">
                                        <c-switch :id="mpp.name" size="sm" v-model="mpp.value" type="text" variant="primary" on="On" off="Off" :pill="true" />
                                      </slot>
                                      <slot v-else>
                                        <b-form-input :id="mpp.name" size="sm" type="text" v-model="mpp.value"></b-form-input>
                                      </slot>
                                    </b-col>
                                  </b-row>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </b-col>
                      </b-row>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-row>

        </b-card>
      </div>

      <div class="card_container">
        <b-card>
          <div slot="header">
            <strong>Payment Schedule</strong>
          </div>
          <b-row>
            <div class="card_container_body">
              <table aria-busy="false" class="table b-table table-sm">
                <tbody>
                  <tr v-if="calcPaymentSchedule.DefaultPaymentSchedule===null" class="b-table-empty-row">
                    <td><div role="alert" aria-live="polite"><div class="text-center my-2">No Payment Schedule loaded yet.</div></div></td>
                  </tr>
                  <tr v-if="calcPaymentSchedule.DefaultPaymentSchedule">
                    <td>
                      <b-row>
                        <b-col md="3"><strong></strong></b-col>
                        <b-col md="9">
                          <table aria-busy="false" class="table b-table table-sm mb-0 border-bottom">
                            <tbody>
                              <tr>
                                <td>
                                  <b-row>
                                    <b-col md="8">Default Payment Schedule</b-col>
                                    <b-col md="3">
                                      <slot>
                                        <b-form-select id="defPaymentSchedule" v-model="calcPaymentSchedule.DefaultPaymentSchedule.Type" :options="enumPaymentType" required></b-form-select>
                                      </slot>
                                    </b-col>
                                  </b-row>

                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b-row>
                                    <b-col md="8">BiWeekly/Weekly Payment Company</b-col>
                                    <b-col md="3">
                                      <slot>
                                        <b-form-select id="paymentCompany" v-model="calcPaymentSchedule.DefaultPaymentSchedule.PaymentCompanyID" required>
                                          <option v-for="o in calcPaymentSchedule.PaymentCompanies" :value="o.ID">{{ o.Name }}</option>
                                        </b-form-select>

                                      </slot>
                                    </b-col>
                                    <b-col md="1">
                                      <b-button id="btnInfo" v-b-modal.PaymentCompanyInfo @click="GetCompanyInfo()">Info</b-button>
                                    </b-col>
                                  </b-row>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </b-col>
                      </b-row>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-row>
        </b-card>

      </div>

      <div class="card_container">
        <b-card>
          <div slot="header">
            <strong>Warranty Defaults</strong>
          </div>
          <b-row>
            <div class="card_container_body">
              <table aria-busy="false" class="table b-table table-sm ">
                <tbody>
                  <tr v-if="calcWarrantyDefaults === null" class="b-table-empty-row">
                    <td><div role="alert" aria-live="polite"><div class="text-center my-2">No Warranty Defaults loaded yet.</div></div></td>
                  </tr>
                  <tr v-if="calcWarrantyDefaults">
                    <td>
                      <b-row>
                        <b-col md="3"><strong></strong></b-col>
                        <b-col md="9">
                          <table aria-busy="false" class="table b-table table-sm mb-0 border-bottom">
                            <tbody>
                              <tr>
                                <td>
                                  <b-row>
                                    <b-col md="8">Dealer cost</b-col>
                                    <b-col md="3">
                                      <slot>
                                        <b-form-input id="defWarrantyCost" size="sm" type="number" v-model="calcWarrantyDefaults.Cost"></b-form-input>
                                      </slot>
                                    </b-col>
                                  </b-row>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b-row>
                                    <b-col md="8">MSRP</b-col>
                                    <b-col md="3">
                                      <slot>
                                        <b-form-input id="defWarrantyMSRP" size="sm" type="number" v-model="calcWarrantyDefaults.MSRP"></b-form-input>
                                      </slot>
                                    </b-col>
                                  </b-row>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b-row>
                                    <b-col md="8">Charge</b-col>
                                    <b-col md="3">
                                      <slot>
                                        <b-form-input id="defWarrantyCharge" size="sm" type="number" v-model="calcWarrantyDefaults.Charge"></b-form-input>
                                      </slot>
                                    </b-col>
                                  </b-row>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b-row>
                                    <b-col md="8">Always Force Warranty Sale in Profit/Payment Scans</b-col>
                                    <b-col md="3">
                                      <slot>
                                        <b-form-checkbox id="chkdefWarrantyForceSale" v-model="calcWarrantyDefaults.ForceSale" />
                                      </slot>
                                    </b-col>
                                  </b-row>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </b-col>
                      </b-row>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-row>
        </b-card>
      </div>

      <div class="card_container">
        <b-card>
          <div slot="header">
            <strong>Wearcare Defaults</strong>
          </div>
          <b-row>
            <div class="card_container_body">
              <table aria-busy="false" class="table b-table table-sm ">
                <tbody>
                  <tr v-if="calcWearcareDefaults === null" class="b-table-empty-row">
                    <td><div role="alert" aria-live="polite"><div class="text-center my-2">No Wearcare Defaults loaded yet.</div></div></td>
                  </tr>
                  <tr v-if="calcWearcareDefaults">
                    <td>
                      <b-row>
                        <b-col md="3"><strong></strong></b-col>
                        <b-col md="9">
                          <table aria-busy="false" class="table b-table table-sm mb-0 border-bottom">
                            <tbody>
                              <tr>
                                <td>
                                  <b-row>
                                    <b-col md="8">Dealer cost</b-col>
                                    <b-col md="3">
                                      <slot>
                                        <b-form-input id="defWearcareCost" size="sm" type="number" v-model="calcWearcareDefaults.Cost"></b-form-input>
                                      </slot>
                                    </b-col>
                                  </b-row>
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  <b-row>
                                    <b-col md="8">Charge</b-col>
                                    <b-col md="3">
                                      <slot>
                                        <b-form-input id="defWearcareCharge" size="sm" type="number" v-model="calcWearcareDefaults.Charge"></b-form-input>
                                      </slot>
                                    </b-col>
                                  </b-row>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </b-col>
                      </b-row>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-row>
        </b-card>
      </div>

      <b-modal id="PaymentCompanyInfo" title="Payment Company Info">
        <div v-html="PopUpMessage"></div>
      </b-modal>
      <loading :show="boolLoading"
                :label="txtLoading">
      </loading>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import cSwitch from '../components/Switch'

export default {
  components: {
    loading,
    cSwitch
  },
  created () {
    var self = this
    axios.get('/api/calcsettings/loaddata')
      .then(response => {
        this.boolLoading = false
        this.calcSettings = response.data.data
        this.calcPaymentSchedule = response.data.payment_schedule
        this.calcWarrantyDefaults = response.data.warrantydefaults
        this.calcWearcareDefaults = response.data.wearcaredefaults
        this.calcFilters = response.data.filter
        this.calcFilters.filter(item => item.__type === 'array').forEach(function (item) {
          item.value.forEach(function (i) {
            if (i.name === 'DontIncludeSecurityDeposits') {
              self.ZeroSecurityDeposit = i
            }
            if (i.name === 'IncludeMultipleSecurityDeposits') {
              self.MultipleSecurityDeposit = i
            }
            if (i.name === 'IncludeBalloonNotes') {
              self.IncludeBalloonNotes = i
            }
            if (i.name === 'BalloonNotesOnly') {
              self.BalloonNotesOnly = i
            }
            if (i.name === 'IncludeFlatFeeAndCapCostPrograms') {
              self.IncludeFlatFeeAndCapCostPrograms = i
            }
          })
        })
      })
      .catch(error => {
        if (error.response.status === 403) { this.$router.push('/login') }

        this.boolLoading = false
        this.errMsg = 'There was an error getting data : ' + error
        this.showDismissibleAlert = true
      })
  },
  data () {
    return {
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      calcSettings: [],
      calcFilters: [],
      calcPaymentSchedule: [],
      calcWarrantyDefaults: [],
      calcWearcareDefaults: [],
      MultipleSecurityDeposit: { },
      ZeroSecurityDeposit: {},
      IncludeBalloonNotes: {},
      BalloonNotesOnly: {},
      enumPaymentType: [
        {value: 0, text: 'Monthly'},
        {value: 1, text: 'Bi-Weekly'},
        {value: 2, text: 'Weekly'}
      ],
      PopUpMessage: ''
    }
  },
  methods: {
    saveOptions () {
      if (!this.calcSettings) {
        this.errMsg = 'Unknown error.'
        this.showDismissibleAlert = true
        return
      }

      this.boolLoading = true
      var obj = {}

      // save settings
      var objData = this.calcSettings.filter(item => item.__type != 'array')
      this.calcSettings.filter(item => item.__type == 'array').forEach(function (item) {
        item.value.forEach(function (i) {
          objData.push(i)
        })
      })

      obj.data = objData
      // save filters
      var objFData = this.calcFilters.filter(item => item.__type != 'array')
      this.calcFilters.filter(item => item.__type === 'array').forEach(function (item) {
        item.value.forEach(function (i) {
          objFData.push(i)
        })
      })
      obj.filter = objFData
      obj.payment_schedule = this.calcPaymentSchedule
      obj.warrantydefaults = this.calcWarrantyDefaults
      obj.wearcaredefaults = this.calcWearcareDefaults

      axios.post('/api/calcsettings/save', obj)
        .then(response => {
          this.errMsg = 'Calculation Settings Saved'
          this.dismissibleType = 'success'
          this.showDismissibleAlert = true
          this.boolLoading = false
          this.$emit('clicked', 'true')
        })
        .catch(error => {
          if (error.response.status === 403 && error.response.statusText.indexOf('403.1') === -1) { this.$router.push('/login') }

          console.log(error)
          this.boolLoading = false
          this.errMsg = 'There was an error saving data : ' + error
          this.showDismissibleAlert = true

          if (error.response.status == 403 && error.response.statusText.indexOf('403.1') !== -1) { this.errMsg = error.response.statusText.replace('403.1', '') }
        })
    },
    GetCompanyInfo () {
      var obj = {}
      obj.CompanyId = this.calcPaymentSchedule.DefaultPaymentSchedule.PaymentCompanyID
      axios.post('/api/calcsettings/getcompanyinfo', obj)
        .then(response => {
          this.PopUpMessage = response.data
        })
        .catch(error => {
          if (error.response.status == 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    }
  },
  watch: {
    MultipleSecurityDeposit: {
      handler (n) {
        if (n.value == true) {
          this.ZeroSecurityDeposit.value = false
        }
      },
      deep: true
    },
    ZeroSecurityDeposit: {
      handler (n) {
        if (n.value == true) {
          this.MultipleSecurityDeposit.value = false
        }
      },
      deep: true
    },
    BalloonNotesOnly: {
      handler (n) {
        if (n.value == true) {
          this.IncludeBalloonNotes.value = n.value
        }
      },
      deep: true
    },
    IncludeBalloonNotes: {
      handler (n) {
        if (n.value == false) {
          this.BalloonNotesOnly.value = n.value
        }
      },
      deep: true
    },
    IncludeFlatFeeAndCapCostPrograms: {
      handler (n) {
        if (n.value == false) {
          this.IncludeFlatFeeAndCapCostPrograms.value = n.value
        }
      },
      deep: true
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
  }

}
</script>
<style scoped>
  .container {
/*    position: relative;
    float: left;*/

    min-width:300px;
  }
  .card_container {
    max-width: 1080px;
    margin:10px;
  }
  .card_container_body {
    width: 100%;
  }
  .col {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  /* Card Header */

  .card-header {
    padding: 1.25rem calc(1.25rem + 15px) !important;
  }

  .mdrive-header-text {
    line-height: 35px;
  }

  #btnSave {
    /* border-radius: .25rem !important; */
    margin-top: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/CalculationSettings.vue